__turbopack_context__.v({
  "collapsed": "work-overview-module-scss-module__PPQ3Pq__collapsed",
  "content": "work-overview-module-scss-module__PPQ3Pq__content",
  "root": "work-overview-module-scss-module__PPQ3Pq__root",
  "toggle": "work-overview-module-scss-module__PPQ3Pq__toggle",
  "u-animation-bounce": "work-overview-module-scss-module__PPQ3Pq__u-animation-bounce",
});
